<div class="container-fluid content-padded">
  <div class="row">
    <div class="col-md-12 subscriptions-content">
      <div class="edit-header mt-4">
        <h3 class="user-title">{{'Update Your Subscriptions' | translate}}</h3>
      </div>
      <ul class="list mt-5">
        <li class="item-list" *ngFor="let sub of subscriptionsArray">
          <label class="col-md-12 custom-control">
            <input type="checkbox" [(ngModel)]="sub.subscribed" [id]="sub.id" class="checkbox mr-3">
            <span *ngIf="!isLoading" class="custom-control-indicator"></span>
            <span *ngIf="isLoading" class="loading title"></span>
            <span class="custom-control-description" *ngIf="!isLoading">{{sub.name}}</span>
          </label>
          <label class="description text-secondary" *ngIf="!isLoading && sub.description">{{sub.description}}</label>
        </li>
      </ul>
      <div class="row">
        <div class="col-md-3 mt-4">
          <button (click)="saveSubscriptions()" class="btn btn-block btn-success save-button">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>
